import { CodeHighlightNode } from '@lexical/code';
import createFallbackNodeClass from './factory.mjs';

var FallbackCodeHighlightNode = createFallbackNodeClass(CodeHighlightNode.getType(), "inline");

export { FallbackCodeHighlightNode as default };
//# sourceMappingURL=code-highlight.mjs.map
